import { Page } from 'layouts/Page';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getAvailableStandardVatReportTypes } from 'redux/reducers/auth/selectors';
import { VerticalMenu } from 'ui/VerticalMenu';
import { Box } from '@mui/material';
import { SALES_REPORTS } from 'redux/reducers/reports/constants';
import { DomesticReports } from 'components/SalesReports/DomesticReports';
import { TMenuItem } from 'ui/VerticalMenu/types';
import { PATHS } from 'routes/constants';
import { useParams } from 'react-router-dom';

export const SalesReportsPage: FC = () => {
	const params = useParams<{ typeOfReport?: string }>();
	const { typeOfReport } = params;
	const salesReports = SALES_REPORTS.find((item) => item.path === typeOfReport);

	const availableStandardVatReportTypes = useSelector(getAvailableStandardVatReportTypes);

	return (
		<Page
			title={`${salesReports?.title ?? ''} ${(salesReports?.title ?? '').indexOf('Sales') < 0 ? ' Sales' : ''} Reports  – EAS Dashboard`}
		>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					flexDirection: { xs: 'column', md: 'row' },
					gap: 1,
				}}
			>
				<Box sx={{ minWidth: '300px' }}>
					{availableStandardVatReportTypes && availableStandardVatReportTypes.length > 0 && (
						<VerticalMenu
							items={
								availableStandardVatReportTypes
									.map((item) => SALES_REPORTS.find((report) => report.type === item))
									.filter(Boolean) as TMenuItem[]
							}
							path={PATHS.SALES_REPORTS_PAGE}
						/>
					)}
				</Box>
				<Box style={{ width: '100%' }}>
					<DomesticReports />
				</Box>
			</Box>
		</Page>
	);
};
